// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3OL8D","modalFooterButton":"ModalNotes_modalFooterButton__5EpsG"};